import React from 'react'

import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
import HFTextInput from 'components/HFInputs/HFTextInput'

import styles from '../Dialog.module.sass'
import TaskPaymentsController from 'controllers/TaskManager/TaskSubControllers/TaskPaymentsController/TaskPaymentsController'
import { TaskNeedsController } from 'controllers/TaskManager/TaskSubControllers/TaskNeedsController/TaskNeedsController'
import { TaskForwardingController } from 'controllers/TaskManager/TaskSubControllers/TaskForwardingController/TaskForwardingController'

export const ClinicalAppointmentForm = (props) => {
	const { i18n } = useGlobal()
	const { data } = props
	const {
		requisition,
		isAdministrative,
		outsideNetwork,
		districts,
		serviceProviders,
		isFromIsland,
		processId,
		appointmentId,
		requisitionType,
		requisitionStateId,
		requisitionId,
	} = data

	return (
		<>
			{isAdministrative && data.requiresChargeAmount && (
				<TaskPaymentsController />
			)}

			{isFromIsland && (
				<TaskNeedsController
					isAdministrative={isAdministrative}
					requisition={requisition}
				/>
			)}

			{isAdministrative && (
				<TaskForwardingController
					outsideNetwork={outsideNetwork}
					districts={districts}
					serviceProviders={serviceProviders}
					providerDescription={requisition?.providerDescription}
					requisitionOutsideNetwork={requisition?.outsideNetwork}
					districtName={requisition?.district?.name}
					processId={processId}
					appointmentId={appointmentId}
					requisitionType={requisitionType}
					requisitionStateId={requisitionStateId}
					requisitionId={requisitionId}
				/>
			)}

			<fieldset className={styles['observation-container']}>
				{isAdministrative ? (
					<ExpandableWidget
						className={styles['observation']}
						heading='h5'
						title={i18n`Administrative Observation`}
					>
						<HFTextInput
							name='administrativeObservation'
							placeholder={i18n`Administrative observation (optional)`}
							multiline={true}
							rows={5}
							noResize
						/>
					</ExpandableWidget>
				) : (
					<ExpandableWidget
						className={styles['observation']}
						heading='h5'
						title={i18n`Clinical Observations`}
					>
						<HFTextInput
							name='medicalObservation'
							placeholder={i18n`Clinical observation (optional)`}
							multiline={true}
							rows={5}
							noResize
						/>
					</ExpandableWidget>
				)}
			</fieldset>
		</>
	)
}
